/*
  Frigid Forage old URL redirects for Shopify theme
  File name: redirect.js

  Add this in layout/theme.liquid before </head>:
  {{ 'redirect.js' | asset_url | script_tag }}

  Notes:
  - Client-side redirect fallback for old pre-Shopify / BigCommerce URLs.
  - Normalizes trailing slashes.
  - Ignores query strings like ?page=2.
  - Checks mapped destination first; if missing, falls back to /collections/all.
*/
(function () {
  'use strict';

  var FALLBACK_URL = '/collections/all';

  var redirects = {
    '/seed-blends/': '/collections/all',
    '/annual-seed-blends/': '/collections/annual-seed-blends',
    '/autumn-quick-plot/': '/collections/autumn-quick-plot',
    '/big-n-beasty/': '/collections/big-n-beasty',
    '/monster-magnet/': '/collections/monster-magnet',
    '/plot-screen/': '/collections/plot-screen',
    '/plow-down-clover/': '/collections/plow-down-clover',
    '/perennial-blends/': '/collections/perennial-blends',
    '/pure-trophy-clover/': '/collections/pure-trophy-clover',
    '/wall-hanger/': '/collections/wall-hanger',
    '/wild-game-buffet/': '/collections/wild-game-buffet',
    '/other/': '/collections/all',
    '/combination-blends/': '/collections/combination-blends',
    '/individual-seeds/': '/collections/individual-seeds',
    '/popular-products/': '/collections/popular-products',
    '/seed-specials/': '/collections/combination-blends',
    '/frigid-forage-logo-products/': '/collections/popular-products',
    '/grizzly-cups/': '/collections/grizzly-cups',
    '/soil-test-kits/': '/collections/all',
    '/food-plot-season/': '/collections/food-plot-season',
    '/promotions/': '/collections/popular-products',
    '/faqs-old/': '/pages/faq',
    '/faqs/': '/pages/faq',
    '/blog/': '/blogs/blog',
    '/dealers/': '/pages/find-a-dealer',
    '/seed-comparison/': '/pages/seed-comparison',
    '/contact-us/': '/pages/contact',
    '/shipping-returns/': '/policies/shipping-policy',

    '/seed-blends/annual-blends/plow-down-clover-25-lb-3-acre-bag/': '/products/seed-blends-annual-blends-plow-down-clover-25-lb-3-acre-bag',
    '/seed-blends/annual-blends/plow-down-clover-big-n-beasty-bags-1-acre/': '/products/seed-blends-annual-blends-plow-down-clover-big-n-beasty-bags-1-acre',
    '/seed-blends/annual-blends/plow-down-clover-8-5-lb-1-acre-bag/': '/products/seed-blends-annual-blends-plow-down-clover-8-5-lb-1-acre-bag',
    '/food-plot-seed/perennial-blends/clover-cover-crop-combo-free-shipping/': '/products/food-plot-seed-perennial-blends-clover-cover-crop-combo-free-shipping',
    '/seed-blends/individual-seeds/forage-chicory-4lb-1-acre-bag/': '/products/seed-blends-individual-seeds-forage-chicory-4lb-1-acre-bag',
    '/seed-blends/annual-blends/plot-screen-50-lb-3-acre-bag/': '/products/seed-blends-annual-blends-plot-screen-50-lb-3-acre-bag',
    '/seed-blends/annual-blends/plot-screen-25-lb-1-5-acre-bag/': '/products/seed-blends-annual-blends-plot-screen-25-lb-1-5-acre-bag',
    '/seed-blends/perennial-blends/pure-trophy-clover-4-lb-1-2-acre-bag/': '/products/seed-blends-perennial-blends-pure-trophy-clover-4-lb-1-2-acre-bag',
    '/food-plot-seed/perennial-blends/wild-game-buffet-4-lb-1-2-acre-bag/': '/products/food-plot-seed-perennial-blends-wild-game-buffet-4-lb-1-2-acre-bag',
    '/food-plot-seed/perennial-blends/wall-hanger-4-lb-1-2-acre-bag/': '/products/food-plot-seed-perennial-blends-wall-hanger-4-lb-1-2-acre-bag',
    '/seed-blends/annual-blends/big-n-beasty-4-lb-1-acre-bag/': '/products/seed-blends-annual-blends-big-n-beasty-4-lb-1-acre-bag',
    '/food-plot-seed/annual-blends/the-original-plot-screen-8-5-lb-1-2-acre-bag/': '/products/food-plot-seed-annual-blends-the-original-plot-screen-8-5-lb-1-2-acre-bag',
    '/seed-blends/annual-blends/big-n-beasty-8-5-2-acre-bag/': '/products/seed-blends-annual-blends-big-n-beasty-8-5-2-acre-bag',
    '/seed-blends/perennial-blends/pure-trophy-clover-25-lb-3-acre-bag/': '/products/seed-blends-perennial-blends-pure-trophy-clover-25-lb-3-acre-bag',
    '/seed-blends/annual-blends/big-n-beasty-25-lb-6-acre-bag/': '/products/seed-blends-annual-blends-big-n-beasty-25-lb-6-acre-bag',
    '/seed-blends/perennial-blends/wild-game-buffet-25-lb-3-acre-bag/': '/products/seed-blends-perennial-blends-wild-game-buffet-25-lb-3-acre-bag',
    '/seed-blends/annual-blends/big-n-beasty-50-lb-12-acre-bag/': '/products/seed-blends-annual-blends-big-n-beasty-50-lb-12-acre-bag',
    '/seed-blends/perennial-blends/pure-trophy-clover-8-5-lb-1-acre-bag/': '/products/seed-blends-perennial-blends-pure-trophy-clover-8-5-lb-1-acre-bag',
    '/seed-blends/perennial-blends/wild-game-buffet-8-5-lb-1-acre-bag/': '/products/seed-blends-perennial-blends-wild-game-buffet-8-5-lb-1-acre-bag',
    '/seed-blends/annual-blends/monster-magnet-8-5-lb-1-2-acre-bag/': '/products/seed-blends-annual-blends-monster-magnet-8-5-lb-1-2-acre-bag',
    '/seed-blends/annual-blends/autumn-quick-plot-8-5-lb-1-2-acre-bag/': '/products/seed-blends-annual-blends-autumn-quick-plot-8-5-lb-1-2-acre-bag',
    '/seed-blends/annual-blends/monster-magnet-25-lb-1-5-acre-bag/': '/products/seed-blends-annual-blends-monster-magnet-25-lb-1-5-acre-bag',
    '/seed-blends/annual-blends/autumn-quick-plot-25-lb-1-5-acre-bag/': '/products/seed-blends-annual-blends-autumn-quick-plot-25-lb-1-5-acre-bag',
    '/seed-blends/perennial-blends/wall-hanger-25-lb-bag-plants-3-acres/': '/products/seed-blends-perennial-blends-wall-hanger-25-lb-bag-plants-3-acres',
    '/seed-blends/other/individual-seeds/bottomland-clover-8-5-lb-bag-plants-1-acre/': '/products/seed-blends-other-individual-seeds-bottomland-clover-8-5-lb-bag-plants-1-acre',
    '/food-plot-seed/other/individual-seeds/alfalfa-8-5-lb-1-2-acre-bag/': '/products/food-plot-seed-other-individual-seeds-alfalfa-8-5-lb-1-2-acre-bag',

    '/popular-products/frigid-forage-logo-products/new-frigid-forage-trucker-snapback-hats-with-leather-patch-charcoal-black/': '/products/popular-products-frigid-forage-logo-products-new-frigid-forage-trucker-snapback-hats-with-leather-patch-charcoal-black',
    '/popular-products/frigid-forage-logo-products/new-frigid-forage-trucker-snapback-hats-with-leather-patch-heather-white/': '/products/popular-products-frigid-forage-logo-products-new-frigid-forage-trucker-snapback-hats-with-leather-patch-heather-white',
    '/popular-products/frigid-forage-logo-products/frigid-forage-trucker-hat-black/': '/products/popular-products-frigid-forage-logo-products-frigid-forage-trucker-hat-black',
    '/popular-products/frigid-forage-logo-products/new-frigid-forage-trucker-hat-moss-khaki/': '/products/popular-products-frigid-forage-logo-products-new-frigid-forage-trucker-hat-moss-khaki',
    '/popular-products/frigid-forage-hooded-sweatshirts-blue/': '/products/popular-products-frigid-forage-hooded-sweatshirts-blue',
    '/hot-buys/frigid-forage-hooded-sweatshirts-navy/': '/products/hot-buys-frigid-forage-hooded-sweatshirts-navy',
    '/popular-products/frigid-forage-logo-products/frigid-forage-t-shirt-blue/': '/products/hot-buys-frigid-forage-t-shirt-blue',
    '/popular-products/frigid-forage-logo-products/frigid-forage-t-shirt-charcoal/': '/products/hot-buys-frigid-forage-t-shirt-charcoal',
    '/popular-products/frigid-forage-logo-products/frigid-forage-t-shirt-navy/': '/products/popular-products-frigid-forage-t-shirt-navy',
    '/popular-products/grizzly-cups/32-oz-frigid-forage-grizzly-grip-cup/': '/products/hot-buys-32-oz-frigid-forage-grizzly-grip-cup',
    '/popular-products/frigid-forage-logo-products/12-frigid-forage-decal/': '/products/popular-products-12-frigid-forage-decal'
  };

  function normalizePath(pathname) {
    var path = pathname || '/';

    try {
      path = decodeURIComponent(path);
    } catch (error) {}

    path = path.toLowerCase().replace(/\/+/g, '/');

    if (path !== '/' && path.charAt(path.length - 1) !== '/') {
      path += '/';
    }

    return path;
  }

  function redirectTo(path) {
    if (!path) return;

    var current = normalizePath(window.location.pathname);
    var target = normalizePath(path);

    if (current === target) return;

    window.location.replace(path);
  }

  function redirectSafely(destination) {
    var target = new URL(destination, window.location.origin);

    fetch(target.pathname, {
      method: 'HEAD',
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        if (response && response.ok) {
          redirectTo(target.pathname);
        } else {
          redirectTo(FALLBACK_URL);
        }
      })
      .catch(function () {
        redirectTo(target.pathname);
      });
  }

  var currentPath = normalizePath(window.location.pathname);
  var destination = redirects[currentPath];

  if (destination) {
    redirectSafely(destination);
  }
})();